// extracted by mini-css-extract-plugin
export default {"container":"LogoTextInput-module__container--RV+Wy","buttonContainer":"LogoTextInput-module__buttonContainer--CQb9P"};